import React from "react";
import { doNothing } from "@edgetier/utilities";

import { ITabsContext } from "./tabs-context.types";

export const defaultContext: ITabsContext = {
    activeTabId: null,
    addTab: doNothing,
    previousActiveTabId: null,
    setTab: doNothing,
    tabIds: [],
};

const ToggleTranslationContext = React.createContext<ITabsContext>(defaultContext);
export default ToggleTranslationContext;
